// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__XkXy2","col":"styles_col__IyOsX"};